/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CheckUsernameErrorResponse,
  CheckUsernameRequest,
  CheckUsernameResponse,
} from './api.schemas';

import { api } from '../util/http';

export const checkUsername = (checkUsernameRequest: CheckUsernameRequest, signal?: AbortSignal) => {
  return api<CheckUsernameResponse>({
    url: `/api/auth/check-username`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: checkUsernameRequest,
    signal,
  });
};

export const getCheckUsernameMutationOptions = <
  TError = CheckUsernameErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkUsername>>,
    TError,
    { data: CheckUsernameRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkUsername>>,
  TError,
  { data: CheckUsernameRequest },
  TContext
> => {
  const mutationKey = ['checkUsername'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkUsername>>,
    { data: CheckUsernameRequest }
  > = (props) => {
    const { data } = props ?? {};

    return checkUsername(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckUsernameMutationResult = NonNullable<Awaited<ReturnType<typeof checkUsername>>>;
export type CheckUsernameMutationBody = CheckUsernameRequest;
export type CheckUsernameMutationError = CheckUsernameErrorResponse;

export const useCheckUsername = <TError = CheckUsernameErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkUsername>>,
      TError,
      { data: CheckUsernameRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkUsername>>,
  TError,
  { data: CheckUsernameRequest },
  TContext
> => {
  const mutationOptions = getCheckUsernameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
